import { trackFileTransfer, trackEvent } from '@/common/utils/telemetry/useTelemetry';
import { extractFileExtension } from '@/common/utils/fileInfoExtractor';

export const trackFileUploadStart = (uploadInfo: {
  fileName: string;
  fileSize: number;
  metadata?: Record<string, unknown>;
}): number => {
  const startTime = performance.now();
  const fileExtension = extractFileExtension(uploadInfo.fileName);

  trackEvent('file_upload_started', {
    file_name: uploadInfo.fileName,
    file_size_bytes: uploadInfo.fileSize,
    file_extension: fileExtension,
    start_time: startTime,
    ...uploadInfo.metadata
  });

  return startTime;
};

export const trackFileUploadComplete = (uploadInfo: {
  startTime: number;
  fileName: string;
  fileSize: number;
  success: boolean;
  errorMessage?: string;
  additionalProperties?: Record<string, unknown>;
}): void => {
  const endTime = performance.now();
  const duration = endTime - uploadInfo.startTime;
  const fileExtension = extractFileExtension(uploadInfo.fileName);

  trackFileTransfer({
    operation: 'upload',
    fileName: uploadInfo.fileName,
    fileSize: uploadInfo.fileSize,
    duration,
    success: uploadInfo.success,
    errorMessage: uploadInfo.errorMessage
  }, {
    file_extension: fileExtension,
    start_time: uploadInfo.startTime,
    end_time: endTime,
    ...uploadInfo.additionalProperties
  });
};
